import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from 'app/app.module';
import { environment } from './environments/environment';

import { hmrBootstrap } from './hmr';

// Load CLDR data and set Syncfusion culture based on browser locale
import 'app/shared/lib/syncfusion-locale';

if ( environment.production ) {
  enableProdMode ();
}

const removeFedBootstrapSplash = () => {
  document.documentElement.classList.remove ( 'fed-auth-loading' );
  document.getElementById ( 'fed-bootstrap-splash' )?.remove ();
};

const bootstrap = () => platformBrowserDynamic ().bootstrapModule ( AppModule )
  .then ( moduleRef => {
    removeFedBootstrapSplash ();
    return moduleRef;
  } )
  .catch ( err => {
    removeFedBootstrapSplash ();
    throw err;
  } );

if ( environment.hmr ) {
  if ( module[ 'hot' ] ) {
    hmrBootstrap ( module, bootstrap );
  } else {
    console.error ( 'HMR is not enabled for webpack-dev-server!' );
    console.log ( 'Are you using the --hmr flag for ng serve?' );
  }
} else {
  bootstrap ().catch ( err => console.log ( err ) );
}
